import { render, staticRenderFns } from "./learner-facets-proficiency.vue?vue&type=template&id=cdb0f2b6&scoped=true&"
import script from "./learner-facets-proficiency.ts?vue&type=script&lang=ts&"
export * from "./learner-facets-proficiency.ts?vue&type=script&lang=ts&"
import style0 from "./learner-facets-proficiency.scss?vue&type=style&index=0&id=cdb0f2b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb0f2b6",
  null
  
)

export default component.exports